/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Shown once the shopper validated their identity (PRIC-168 CA5, CA10). PRIC-169 replaces this with the
 * "Crear contraseña" screen, which posts back `identityFlow` (encrypted customer ID and change-password token).
 */
export default function IdentityVerified({ identityFlow: _identityFlow }: { identityFlow: string }): ReactElement {
    const { t } = useTranslation('extPriceshoes');

    return (
        <div className="space-y-2">
            <h1 className="text-2xl font-semibold text-foreground">{t('login.verification.verifiedTitle')}</h1>
            <p role="status" className="text-foreground">
                {t('login.verification.verifiedDescription')}
            </p>
        </div>
    );
}
